import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Edit } from '@material-ui/icons';
import DataTable from '../../../../components/DataTable/DataTable';
import DeleteConfirm from '../../../../components/DataTable/DeleteConfirm';
import RequestDialog from '../RequestDialog/RequestDialog';
import CredentialService from '../../../../services/CredentialService/CredentialService';
import { useSetRecoilState, useRecoilValue } from 'recoil';
import { alertState, rolePermission } from '../../../../recoil-store/recoil-state';

let deletedCredOwner = [];
let deletedCredRequester = [];
let setSelectedCredRow;

function CredentialTab(props) {
    const { t } = useTranslation();
    const { open, fetchData, setOpen, customColumn, setCustomColumn, searchData, loading, setSearchKeyData } = props;
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const label = 'CONTENT.CREDENTIAL-TAB.';
    const setAlert = useSetRecoilState(alertState);
    const permissions = useRecoilValue(rolePermission);

    const handleRowsDelete = (rowsDeleted, dataArray, setSelectedRows) => {
        setOpenDelete(true)
        deletedCredOwner = [];
        deletedCredRequester = [];
        for (let i of rowsDeleted.data) {
            if (searchData[i.dataIndex].access_type === 'Owner') {
                deletedCredOwner.push(searchData[i.dataIndex].connection_id);
            }
            else if (searchData[i.dataIndex].access_type === 'Requester') {
                deletedCredRequester.push(searchData[i.dataIndex].connection_id);
            }
        }
        setSelectedCredRow = setSelectedRows;
    }

    const deleteCredential = async () => {
        let idsOwner = deletedCredOwner;
        let idsRequester = deletedCredRequester;
        setLoadingDelete(true);
        let response = { status: true };
        if (idsOwner.length > 0) { response = await CredentialService.deleteCredential(idsOwner); }
        if (response) {
            if (response.message) {
                setAlert(alert => ({ ...alert, show: true, message: t(label + response.message), severity: response.status ? 'success' : 'error' }))
            }
            if (response.status && idsRequester.length > 0) {
                response = await CredentialService.deleteCredentialRequest(idsRequester);
                if (response) {
                    setAlert(alert => ({ ...alert, show: true, message: t("MESSAGES.CREDENTIAL.CONNECTION-REQUEST-" + response.message), severity: response.status ? 'success' : 'error' }))
                }
                else {
                    setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }))
                }
            }
        }
        else {
            setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }))
        }
        fetchData(0);
        setSelectedCredRow([]);
        setLoadingDelete(false);
    };

    useEffect(() => {
        const column = [{
            id: 0,
            name: "id",
            label: " ",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    if (searchData && searchData[dataIndex]) {
                        return <span>{dataIndex + 1}.</span>;
                    }
                },
            },
        }, {
            id: 1,
            name: 'connection_name',
            label: t('CONTENT.DATATABLE.COLUMNS.CREDENTIAL_NAME'),
            options: { filter: true, sort: true }
        }, {
            id: 2,
            name: 'request_status',
            label: t('CONTENT.DATATABLE.COLUMNS.REQUEST_STATUS'),
            options: { filter: true, sort: false }
        }, {
            id: 3,
            name: 'access_type',
            label: t('CONTENT.DATATABLE.COLUMNS.ACCESS_TYPE'),
            options: { filter: true, sort: true }
        }, {
            id: 4,
            name: 'connection_owner',
            label: t('CONTENT.DATATABLE.COLUMNS.CREDENTIAL_OWNER'),
            options: { filter: true, sort: true }
        }, {
            id: 5,
            name: 'actions',
            label: t(label + 'ACTIONS'),
            options: {
                filter: false, sort: false, display: permissions?.data.includes('CONNECTION_UPDATE') ? true : 'excluded',
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    if (searchData && searchData[dataIndex]) {
                        return (
                            <div>
                                {searchData[dataIndex]?.access_type === 'Owner' &&
                                    <Link data-test="credential-link"
                                        to={`/management/vault/custom-credentials/${searchData[dataIndex].connection_id}/edit`}
                                    >
                                        <Edit />
                                    </Link>
                                }
                            </div>
                        );
                    }
                },
            }
        }];
        setCustomColumn(column)
        setSearchKeyData(["connection_name", "request_status", "connection_owner", "access_type"])
    }, [searchData, t])

    return (
        <div data-test="credential-tab" className='hei-100'>
            <DataTable
                data-test="credentialtab-datatable"
                customColumns={customColumn}
                onRowsDelete={handleRowsDelete}
                selectableRows={permissions?.data.includes('CONNECTION_DELETE') ? 'multiple' : 'none'}
                data={searchData}
                title={t(label + 'CREDENTIAL-LIST')}
                loading={loading}
                loadingDelete={loadingDelete}
            />
            {openDelete && <DeleteConfirm setOpenDelete={setOpenDelete} message={t(label + 'DELETE-WARNING')} deleteFunc={deleteCredential} />}
            {open && <RequestDialog setOpen={setOpen} fetchData={fetchData} tabIndex={0} />}
        </div>
    );
}

export default CredentialTab;
